import React from 'react'
import { connect } from 'react-redux'

import {
  searchResultSelector,
  querySelector,
  availableSelector,
  searchIsPendingSelector,
} from 'selectors'
import { search } from 'actions'

import ConsultantList from 'components/ConsultantList'
import NoResults from 'components/NoResults'
import Spinner from 'components/Spinner'

class SearchResult extends React.Component {
  componentDidMount = () =>
    this.props.search({
      query: this.props.query,
      available: this.props.available,
      triggerNavigation: false,
    })

  render() {
    if (this.props.isPending) return <Spinner />
    return this.props.consultantIds.length > 0 ? (
      <ConsultantList
        consultantIds={this.props.consultantIds}
        availabilityDropdown
      />
    ) : (
      <NoResults />
    )
  }
}

const mapStateToProps = state => ({
  isPending: searchIsPendingSelector(state),
  consultantIds: searchResultSelector(state) || [],
  query: querySelector(state),
  available: availableSelector(state),
})

const mapDispatchToProps = { search }

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult)



// WEBPACK FOOTER //
// ./src/pages/SearchResults.js